{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://forms/release",
  "title": "Release",
  "type": "object",
  "properties": {
    "id": {
      "$ref": "module://release#properties/id"
    },
    "name": {
      "$ref": "module://release#properties/name",
      "required": true
    },
    "expectedReleaseDate": {
      "$ref": "module://release#properties/expectedReleaseDate",
      "required": true
    },
    "ignoreBrokerage": {
      "$ref": "module://release#properties/ignoreBrokerage",
      "disabledWhen": {
        "field": "#/properties/releaseStatus",
        "equals": "Released"
      }
    },
    "soldShareOnlyToBroker": {
      "$ref": "module://release#properties/soldShareOnlyToBroker",
      "disabledWhen": {
        "field": "#/properties/releaseStatus",
        "equals": "Released"
      }
    },
    "bulkExecutionName": {
      "$ref": "module://release#properties/bulkExecutionName"
    },
    "description": {
      "$ref": "module://release#properties/description"
    },
    "releaseStatus": {
      "type": "string",
      "title": "Release Status",
      "widget": "hidden"
    },
    "submitted": {
      "type": "boolean",
      "default": false,
      "widget": "hidden"
    },
    "itemTabs": {
      "type": "object",
      "title": "Item Tabs",
      "widget": "hidden",
      "hiddenWhen": {
        "anyOf": [
          {
            "field": "#/properties/submitted",
            "notEquals": true
          },
          {
            "allOf": [
              {
                "field": "#/properties/submitted",
                "equals": true
              },
              {
                "meta": "mode",
                "equals": "create"
              }
            ]
          }
        ]
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_RELEASE",
      "successMessage": "Release detail saved."
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "actionId": "SAVE_RELEASE",
          "successMessage": "",
          "constants": {}
        }
      },
      "lifecycle": {
        "submitBehavior": "stay"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_RELEASE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "actionId": "SAVE_RELEASE",
          "successMessage": "Release detail saved.",
          "constants": {}
        }
      }
    },
    "view": {
      "readOnly": true
    }
  }
}
